// Shared sector data used across home grid and sector detail pages.
import {
  HeartPulse,
  GraduationCap,
  Building2,
  Users,
  Cpu,
} from "lucide-react";

export const SECTORS = [
  {
    slug: "healthcare",
    name: "Healthcare Transformation",
    short: "Healthcare",
    Icon: HeartPulse,
    tagline: "Building resilient healthcare systems for a healthier Bharat.",
    intro:
      "From district hospitals to digital diagnostics — we architect public and private health systems that scale equitably across India's diverse geographies.",
    image:
      "https://images.unsplash.com/photo-1741707039536-113e200f9e0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w7NTY2OTV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBoZWFsdGhjYXJlJTIwbWVkaWNhbCUyMGhvc3BpdGFsJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3ODEzMjg0Nnww&ixlib=rb-4.1.0&q=85",
    capabilities: [
      "Public health systems & national missions",
      "Digital healthcare and telemedicine architecture",
      "Diagnostics ecosystems & lab networks",
      "Medical infrastructure planning",
      "Rural healthcare access models",
      "Public-Private Partnership structuring",
    ],
    metrics: [
      { value: "240+", label: "Health Facilities Advised" },
      { value: "9", label: "State Engagements" },
      { value: "4.6M", label: "Citizens Reached" },
    ],
  },
  {
    slug: "education",
    name: "Education & Skill Development",
    short: "Education",
    Icon: GraduationCap,
    tagline:
      "Transforming India's demographic dividend into national capability.",
    intro:
      "We partner with universities, ministries, and skill councils to modernize learning, align curricula with industry, and build the workforce of a $10 trillion economy.",
    image:
      "https://images.unsplash.com/photo-1764943630631-b63aadf86e19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBtb2Rlcm4lMjBlZHVjYXRpb24lMjB1bml2ZXJzaXR5JTIwY2FtcHVzfGVufDB8fHx8MTc3ODEzMjg0Nnww&ixlib=rb-4.1.0&q=85",
    capabilities: [
      "Workforce & skilling readiness frameworks",
      "Higher education transformation",
      "Industry-academia integration",
      "AI and digital education stacks",
      "Institutional governance reform",
      "Outcomes-based funding models",
    ],
    metrics: [
      { value: "32", label: "Institutions Modernized" },
      { value: "180K", label: "Learners Impacted" },
      { value: "12", label: "States Reached" },
    ],
  },
  {
    slug: "infrastructure",
    name: "Infrastructure & Nation Building",
    short: "Infrastructure",
    Icon: Building2,
    tagline: "Creating the physical backbone of a developed Bharat.",
    intro:
      "Smart cities, industrial corridors, urban modernization and rural connectivity — we structure execution frameworks for India's most ambitious infrastructure mandates.",
    image:
      "https://images.pexels.com/photos/17275744/pexels-photo-17275744.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    capabilities: [
      "Smart cities & urban planning",
      "Industrial corridor strategy",
      "Logistics & multimodal networks",
      "Rural infrastructure design",
      "Sustainability & ESG integration",
      "Large-scale execution PMOs",
    ],
    metrics: [
      { value: "₹14K Cr", label: "Capex Advised" },
      { value: "26", label: "Programs Live" },
      { value: "8", label: "Industrial Corridors" },
    ],
  },
  {
    slug: "workforce",
    name: "Workforce Enhancement",
    short: "Workforce",
    Icon: Users,
    tagline: "Empowering institutions through human capital transformation.",
    intro:
      "From digital governance training to enterprise workforce systems, we build the institutional capacity that turns policy into outcomes.",
    image:
      "https://images.unsplash.com/photo-1758873269035-aae0e1fd3422?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBidXNpbmVzcyUyMGxlYWRlcnNoaXAlMjBib2FyZHJvb20lMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc4MTMyODM0fDA&ixlib=rb-4.1.0&q=85",
    capabilities: [
      "Workforce modernization strategy",
      "Digital governance training programs",
      "Public sector capacity building",
      "Talent transformation roadmaps",
      "Enterprise workforce systems",
      "Performance management redesign",
    ],
    metrics: [
      { value: "5,200+", label: "Officers Trained" },
      { value: "14", label: "Departments" },
      { value: "98%", label: "Program Completion" },
    ],
  },
  {
    slug: "digital-bharat",
    name: "Digital Bharat",
    short: "Digital Bharat",
    Icon: Cpu,
    tagline: "Digitally enabling the next era of governance and growth.",
    intro:
      "We help institutions build the digital public infrastructure of tomorrow — AI governance, citizen-centric platforms, and data systems engineered for scale.",
    image:
      "https://images.pexels.com/photos/30723974/pexels-photo-30723974.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    capabilities: [
      "AI governance frameworks",
      "Digital transformation roadmaps",
      "eGovernance platform strategy",
      "National data systems",
      "Smart administration design",
      "Citizen-centric platform design",
    ],
    metrics: [
      { value: "11", label: "DPI Programs" },
      { value: "6.4M", label: "Citizens Onboarded" },
      { value: "3", label: "National Platforms" },
    ],
  },
];

export const getSector = (slug) => SECTORS.find((s) => s.slug === slug);
